import React from 'react'
import { ThemeProvider } from 'styled-components';
import { Provider } from "react-redux";

import store from './store'
import theme from './theme';
import Scenes from './scenes'



export default class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <ThemeProvider theme={ theme }>
          <Scenes />
        </ThemeProvider>
      </Provider>
    )
  }
}
